import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useStorePageStore from "../../../stores/useStorePageStore";
import { Link, Stack, Typography } from "@mui/material";
import show from "../../../api/auth/storePages/show";
import StorePageForm from "../../../components/form/storePages/StorePageForm";

export default function EditStorePage() {
  const { updateStorePage, storePageById } = useStorePageStore();

  const { id } = useParams();

  const storePage = storePageById(id);

  useEffect(() => {
    show(id, (response) => {
      updateStorePage(response);
    });
  }, []);

  return (
    <Stack>
      <Stack>
        <Typography variant="h4">
          Edit Store Page
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body1">
          URL: <Link href={`https://ims.wush.life/stores/${storePage.uuid}`}>
            https://ims.wush.life/stores/{storePage.uuid}
          </Link>
        </Typography>
      </Stack>
      <Stack>
        <StorePageForm storePage={storePage} />
      </Stack>
    </Stack>
  );
}